import { GenericFunction } from '../GenericFunction';
import { Stepper } from '../../Merge/Stepper/Stepper';
import { convertToSeries } from '../../Util';


/**
 * 
 */
export class ValueFunction extends GenericFunction {
  constructor(f, {label, description, parameters = [], maxInputSize = 1} = {}) {
    super(f, {label, description, parameters, maxInputSize});
  }

  applyToTimeSeries(args = {}) {
    let mergeIterator = new Stepper(args);
    let outputData = [];

    for (const datum of mergeIterator) {
      let index = datum.index;
      let mergeParams = datum.values;

      outputData.push([index, this(mergeParams)]);
    }

    return convertToSeries(outputData);
  }
}